module.exports = __webpack_public_path__ + "img/pic.c2f7a5bc.png";